/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '../../ui-elements/qr-code/qr-code-panel/qr-code-panel.component.ngfactory';
import * as import4 from '../../ui-elements/qr-code/qr-code-panel/qr-code-panel.component';
import * as import5 from '../../orchestration/navigation.service';
import * as import6 from '@angular/common';
import * as import7 from '../../store/store-details-panel/store-details-panel.component.ngfactory';
import * as import8 from '../../store/store-details-panel/store-details-panel.component';
import * as import9 from '../../orchestration/session.model';
import * as import10 from '../../orchestration/responsive.service';
import * as import11 from '../../ordering-context/ordering-context.model';
import * as import12 from '../../inputs/form/field-group/field-group.component.ngfactory';
import * as import13 from '../../inputs/form/field-group/field-group.component';
import * as import14 from '@angular/forms';
import * as import15 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import16 from '../../ui-elements/icon/icon.component';
import * as import17 from '../order-extras-panel/order-extras-panel.component.ngfactory';
import * as import18 from '../order-extras-panel/order-extras-panel.component';
import * as import19 from '../../ui-elements/card-brand/card-brand.component.ngfactory';
import * as import20 from '../../ui-elements/card-brand/card-brand.component';
import * as import21 from '../../buttons/button/button.component.ngfactory';
import * as import22 from '../../buttons/button/button.component';
import * as import23 from '../order-totals-panel/order-totals-panel.component.ngfactory';
import * as import24 from '../order-totals-panel/order-totals-panel.component';
import * as import25 from '../order.model';
import * as import26 from '../../html-utils/html.pipe';
import * as import27 from '@angular/platform-browser';
import * as import28 from '../../string-utils/possessive.pipe';
import * as import29 from '../../string-utils/currency.pipe';
import * as import30 from './order-details-panel.component';
const styles_OrderDetailsPanelComponent:any[] = ([] as any[]);
export const RenderType_OrderDetailsPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderDetailsPanelComponent,
  data: {}
}
);
function View_OrderDetailsPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'order-transfer'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    import0.ɵpod([
      'store',
      'groupOrderName'
    ]
    ),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,4,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,3).transform('woa.message.order.summary.transferredToGroupOrder',ck(v,2,0,co.recentOrder.initiatedOrder.store.collectiveStoreName,import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>v.parent).parent),1),co.recentOrder.orderInitiation.transferTargetName)))))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'order-qr'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-qr-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-qr-code-panel',([] as any[]),(null as any),(null as any),(null as any),import3.View_QrCodePanelComponent_0,import3.RenderType_QrCodePanelComponent)),
    import0.ɵdid(49152,(null as any),0,import4.QrCodePanelComponent,[import5.NavigationService],{
      value: [
        0,
        'value'
      ]
      ,
      displayValue: [
        1,
        'displayValue'
      ]
      ,
      message: [
        2,
        'message'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.recentOrder.placedOrder.lookupCode;
    const currVal_2:any = co.recentOrder.placedOrder.receiptId;
    const currVal_3:any = import0.ɵinlineInterpolate(1,'',import0.ɵunv(v,7,2,import0.ɵnov(v,8).transform('woa.label.order.details.qrCode')),'');
    ck(v,7,0,currVal_1,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.order.details.qrCode'));
    ck(v,3,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'order-receiptId'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import6.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-time']),
    import0.ɵpod(['receiptId']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'order-receiptId';
    const currVal_2:any = ck(v,2,0,co.orderTimeLabel);
    ck(v,1,0,currVal_1,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,5,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,4).transform('woa.label.order.details.receiptId',ck(v,3,0,co.recentOrder.placedOrder.receiptId)))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showQrCode;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.showQrCode;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-time'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['time']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,3,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform(co.orderTimeLabel,ck(v,1,0,co.orderTime)))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_7)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.placedOrder.requestId;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.orderTimeLabel;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.orderInitiation.transferTargetId;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.recentOrder.orderInitiation.transferTargetId;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-details-panel',[[
        'class',
        'order-store'
      ]
    ],(null as any),(null as any),(null as any),import7.View_StoreDetailsPanelComponent_0,import7.RenderType_StoreDetailsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import8.StoreDetailsPanelComponent,[
      import9.SessionModel,
      import10.ResponsiveService,
      import11.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,{
      store: [
        0,
        'store'
      ]
      ,
      intention: [
        1,
        'intention'
      ]
      ,
      summary: [
        2,
        'summary'
      ]
      ,
      showStoreImage: [
        3,
        'showStoreImage'
      ]
      ,
      showTelephone: [
        4,
        'showTelephone'
      ]
      ,
      showMoreDetails: [
        5,
        'showMoreDetails'
      ]
      ,
      showStatus: [
        6,
        'showStatus'
      ]
      ,
      showActions: [
        7,
        'showActions'
      ]
      ,
      showMap: [
        8,
        'showMap'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.initiatedOrder.store;
    const currVal_1:any = co.OrderingContextIntention.NONE;
    const currVal_2:any = true;
    const currVal_3:any = false;
    const currVal_4:any = true;
    const currVal_5:any = false;
    const currVal_6:any = false;
    const currVal_7:any = false;
    const currVal_8:any = true;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  },(null as any));
}
function View_OrderDetailsPanelComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'delivery-address-instructions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.orderPlacement.deliveryInstructions;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'woa-field-group',[[
        'class',
        'delivery-address'
      ]
    ],(null as any),(null as any),(null as any),import12.View_FieldGroupComponent_0,import12.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import13.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import14.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import13.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'div',[[
        'class',
        'delivery-address-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted(0,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),0,3,'div',[[
        'class',
        'delivery-address-mobile'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpod(['phoneNumber']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_10)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.label.order.details.deliveringTo';
    ck(v,1,0,currVal_0);
    const currVal_3:any = co.recentOrder.orderPlacement.deliveryInstructions;
    ck(v,13,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.recentOrder.orderPlacement.address.formattedAddress;
    ck(v,5,0,currVal_1);
    const currVal_2:any = import0.ɵunv(v,8,0,import0.ɵnov(v,10).transform('woa.label.order.details.phoneNumber',ck(v,9,0,co.recentOrder.orderPlacement.mobilePhone)));
    ck(v,8,0,currVal_2);
  });
}
function View_OrderDetailsPanelComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'order-request-item-details-header-icon'
      ]
    ],(null as any),(null as any),(null as any),import15.View_IconComponent_0,import15.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import16.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'tags';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderDetailsPanelComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-extras-panel',[[
        'class',
        'order-request-item-details-component-extras'
      ]
    ],(null as any),(null as any),(null as any),import17.View_OrderExtrasPanelComponent_0,import17.RenderType_OrderExtrasPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import18.OrderExtrasPanelComponent,([] as any[]),{
      item: [
        0,
        'item'
      ]
      ,
      showTotal: [
        1,
        'showTotal'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit;
    const currVal_1:any = true;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'order-request-item-details-component'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-request-item-details-component-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_17)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = ((v.context.$implicit.orderedExtras == null)? (null as any): v.context.$implicit.orderedExtras.length);
    ck(v,6,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-extras-panel',[[
        'class',
        'order-request-item-details-extras'
      ]
    ],(null as any),(null as any),(null as any),import17.View_OrderExtrasPanelComponent_0,import17.RenderType_OrderExtrasPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import18.OrderExtrasPanelComponent,([] as any[]),{
      item: [
        0,
        'item'
      ]
      ,
      showTotal: [
        1,
        'showTotal'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit;
    const currVal_1:any = true;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'order-request-item'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-request-item-qty'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'order-request-item-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'order-request-item-details-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_15)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-request-item-details-header-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_16)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_18)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-request-item-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = v.context.$implicit.dealId;
    ck(v,10,0,currVal_2);
    const currVal_4:any = v.context.$implicit.compositeOrderItems;
    ck(v,17,0,currVal_4);
    const currVal_5:boolean = (!((v.context.$implicit.compositeOrderItems == null)? (null as any): v.context.$implicit.compositeOrderItems.length) && ((v.context.$implicit.orderedExtras == null)? (null as any): v.context.$implicit.orderedExtras.length));
    ck(v,20,0,currVal_5);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(2,'order-request-item-',(<any>(<any>v.parent).parent).context.index,'.',v.context.index,'');
    ck(v,0,0,currVal_0);
    const currVal_1:any = v.context.$implicit.quantity;
    ck(v,3,0,currVal_1);
    const currVal_3:any = v.context.$implicit.name;
    ck(v,13,0,currVal_3);
    const currVal_6:any = import0.ɵunv(v,24,0,ck(v,25,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),2),((v.context.$implicit.initiatedTotal == (undefined as any))? v.context.$implicit.localTotal: v.context.$implicit.initiatedTotal)));
    ck(v,24,0,currVal_6);
  });
}
function View_OrderDetailsPanelComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'order-request-subtotal'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-request-subtotal-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpod(['name']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-request-subtotal-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,5).transform((<any>(<any>v.parent).parent).context.$implicit.subtotalLabel,ck(v,4,0,(<any>(<any>v.parent).parent).context.$implicit.name)));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,8,0,ck(v,9,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),2),(<any>(<any>v.parent).parent).context.$implicit.subTotal));
    ck(v,8,0,currVal_1);
  });
}
function View_OrderDetailsPanelComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'woa-field-group',[[
        'class',
        'order-request'
      ]
    ],(null as any),(null as any),(null as any),import12.View_FieldGroupComponent_0,import12.RenderType_FieldGroupComponent)),
    import0.ɵdid(49152,(null as any),0,import13.FieldGroupComponent,([] as any[]),{
      title: [
        0,
        'title'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['name']),
    import0.ɵprd(5120,(null as any),import14.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import13.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_14)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_19)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.getRequestHeading((<any>v.parent).context.$implicit);
    const currVal_1:any = ck(v,2,0,(<any>v.parent).context.$implicit.name);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = (<any>v.parent).context.$implicit.items;
    ck(v,6,0,currVal_2);
    const currVal_3:any = co.totalTransfers;
    ck(v,9,0,currVal_3);
  },(null as any));
}
function View_OrderDetailsPanelComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_13)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.items.length;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_OrderDetailsPanelComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-field-group',[[
        'class',
        'order-notes'
      ]
    ],(null as any),(null as any),(null as any),import12.View_FieldGroupComponent_0,import12.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import13.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import14.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import13.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'div',[[
        'class',
        'order-notes-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.heading.order.notes';
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (co.recentOrder.orderPlacement.requestId? co.recentOrder.orderPlacement.customerNotes: co.orderingContextModel.customerNotes);
    ck(v,5,0,currVal_1);
  });
}
function View_OrderDetailsPanelComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-card-brand',[[
        'class',
        'order-payment-method-brand card-brand'
      ]
    ],(null as any),(null as any),(null as any),import19.View_CardBrandComponent_0,import19.RenderType_CardBrandComponent)),
      import0.ɵdid(573440,(null as any),0,import20.CardBrandComponent,([] as any[]),{brand: [
        0,
        'brand'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.orderPlacement.paymentAuthorisation.paymentCardBrand;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderDetailsPanelComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'order-payment-method'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_23)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-payment-method-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpod([
      'points',
      'card'
    ]
    ),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (((co.recentOrder.orderPlacement.paymentAuthorisation.paymentType === 1) || (co.recentOrder.orderPlacement.paymentAuthorisation.paymentType === co.PaymentType.SAVED_CREDIT_CARD)) || (co.recentOrder.orderPlacement.paymentAuthorisation.paymentType === co.PaymentType.NEW_CREDIT_CARD));
    ck(v,3,0,currVal_0);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,8).transform(co.paymentMethod,ck(v,7,0,co.memberAvailableRedemptionPoints,co.recentOrder.orderPlacement.paymentAuthorisation.paymentCardLast4)));
    ck(v,6,0,currVal_1);
  });
}
function View_OrderDetailsPanelComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'order-payment-action'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.requestInvoice()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import21.View_ButtonComponent_0,import21.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import22.ButtonComponent,[
      import0.ElementRef,
      import9.SessionModel,
      import0.ChangeDetectorRef,
      import10.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      prominence: [
        1,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.order.sendInvoice';
    const currVal_28:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderDetailsPanelComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'woa-field-group',[[
        'class',
        'order-payment'
      ]
    ],(null as any),(null as any),(null as any),import12.View_FieldGroupComponent_0,import12.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import13.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import14.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import13.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'woa-order-totals-panel',[[
        'class',
        'order-payment-totals'
      ]
    ],(null as any),(null as any),(null as any),import23.View_OrderTotalsPanelComponent_0,import23.RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import24.OrderTotalsPanelComponent,[
      import11.OrderingContextModel,
      import25.OrderModel,
      import5.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,{
      recentOrder: [
        0,
        'recentOrder'
      ]
      ,
      showZeroTip: [
        1,
        'showZeroTip'
      ]
      ,
      showSavings: [
        2,
        'showSavings'
      ]
      ,
      canEditTip: [
        3,
        'canEditTip'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_22)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_24)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.heading.order.paymentDetails';
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.recentOrder;
    const currVal_2:any = false;
    const currVal_3:any = false;
    const currVal_4:any = false;
    ck(v,5,0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = (co.recentOrder.orderPlacement.requestId && (co.totalPayment > 0));
    ck(v,8,0,currVal_5);
    const currVal_6:boolean = (((!co.recentOrder.pending && co.recentOrder.orderPlacement.requestId) && (co.totalPayment > 0)) && ((co.sessionModel.currentApp == null)? (null as any): co.sessionModel.currentApp.orderReceivedEmail.id));
    ck(v,11,0,currVal_6);
  },(null as any));
}
function View_OrderDetailsPanelComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_12)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_20)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_21)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.transferRequestDetails;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = (!co.recentOrder.orderInitiation.transferTargetId && ((co.recentOrder.orderPlacement.requestId && co.recentOrder.orderPlacement.customerNotes) || (!co.recentOrder.orderPlacement.requestId && co.orderingContextModel.customerNotes)));
    ck(v,6,0,currVal_1);
    const currVal_2:any = (co.showPayment && !co.recentOrder.orderInitiation.transferTargetId);
    ck(v,9,0,currVal_2);
  },(null as any));
}
export function View_OrderDetailsPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import26.HtmlPipe,[import27.DomSanitizer]),
    import0.ɵpid(0,import28.PossessivePipe,([] as any[])),
    import0.ɵpid(0,import29.CurrencyPipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_8)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_9)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_11)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import30.OrderDetailsPanelComponent = v.component;
    const currVal_0:any = co.showFulfilmentDetails;
    ck(v,4,0,currVal_0);
    const currVal_1:any = ((co.showLocationDetails && !co.recentOrder.orderInitiation.transferTargetId) && (co.recentOrder.orderInitiation.orderTypeEnum !== co.OrderType.ORDER_AT_TABLE));
    ck(v,7,0,currVal_1);
    const currVal_2:any = (((co.showFulfilmentDetails && !co.recentOrder.orderInitiation.transferTargetId) && co.recentOrder.placedOrder.requestId) && (co.recentOrder.orderInitiation.orderTypeEnum === co.OrderType.ORDER_DELIVERY));
    ck(v,10,0,currVal_2);
    const currVal_3:any = co.showOrderDetails;
    ck(v,13,0,currVal_3);
  },(null as any));
}
function View_OrderDetailsPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-details-panel',([] as any[]),(null as any),(null as any),(null as any),View_OrderDetailsPanelComponent_0,RenderType_OrderDetailsPanelComponent)),
    import0.ɵdid(573440,(null as any),0,import30.OrderDetailsPanelComponent,[
      import9.SessionModel,
      import11.OrderingContextModel,
      import25.OrderModel,
      import5.NavigationService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const OrderDetailsPanelComponentNgFactory:import0.ComponentFactory<import30.OrderDetailsPanelComponent> = import0.ɵccf('woa-order-details-panel',import30.OrderDetailsPanelComponent,View_OrderDetailsPanelComponent_Host_0,{
  recentOrder: 'recentOrder',
  showFulfilmentDetails: 'showFulfilmentDetails',
  showLocationDetails: 'showLocationDetails',
  showOrderDetails: 'showOrderDetails',
  showPayment: 'showPayment'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/order/order-details-panel/order-details-panel.component.ngfactory.ts